export const fetchSubmissionCriteriaDetailsSelectors = {
    selectCriteriaByPatternId: (arg, result) => ({
        ...result,
        data: result?.data?.[arg.patternId] || [],
    }),
    selectReasoningByPatternId: (arg, result) => ({
        ...result,
        data: result?.data?.[arg.patternId]?.[0] || '',
    }),
}
